import { createContext } from 'react';

export const chatContext = createContext<any>({});
